/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SettingsState } from './types';
import { getEmergencyServices, createEmergencyService, deleteEmergencyService } from './settingsApi';

const initialState: SettingsState = {
    emergencyServices: [],
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    success: false,
    error: null,
};

const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEmergencyServices.pending, (state) => {
                state.isFetching = true;
                state.error = null;
            })
            .addCase(getEmergencyServices.fulfilled, (state, action) => {
                state.isFetching = false;
                state.emergencyServices = action.payload.data || [];
                state.success = true;
            })
            .addCase(getEmergencyServices.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.error.message || 'Failed to fetch emergency services';
            });
        builder
            .addCase(createEmergencyService.pending, (state) => {
                state.isCreating = true;
                state.error = null;
            })
            .addCase(createEmergencyService.fulfilled, (state, action) => {
                state.isCreating = false;
                state.emergencyServices.push(action.payload);
                state.success = true;
            })
            .addCase(createEmergencyService.rejected, (state, action) => {
                state.isCreating = false;
                state.error = action.payload as string || 'Failed to create emergency service';
            });
        builder
            .addCase(deleteEmergencyService.pending, (state) => {
                state.isDeleting = true;
                state.error = null;
            })
            .addCase(deleteEmergencyService.fulfilled, (state) => {
                state.isDeleting = false;
                state.success = true;
            })
            .addCase(deleteEmergencyService.rejected, (state, action) => {
                state.isDeleting = false;
                state.error = action.payload as string || 'Failed to delete emergency service';
            });
    },
});

export default settingsSlice.reducer;
